import React from 'react';
import { SvgIcon } from '@material-ui/core';

export const ApiIsometricIcon = () => (
  <SvgIcon
    style={{ width: 'auto', height: 'auto', fill: 'none' }}
    width="109"
    height="83"
    viewBox="0 0 109 83"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M108.892 40.4712L108.894 40.4697V36.0148L103.884 38.1455L73.4371 20.5748C72.3478 19.9459 70.5822 19.9459 69.4936 20.5748L11.7918 53.8929L0.2229 57.3937V61.8501V61.8523V61.8612L0.224383 61.8619C0.228818 62.2706 0.499303 62.6786 1.03954 62.9904L34.093 82.0739C35.1823 82.7028 36.9479 82.7028 38.0365 82.0739L108.079 41.6285C108.632 41.3093 108.901 40.8888 108.892 40.4712Z"
      fill="#C8E2FF"
    />
    <path
      d="M0.222168 57.3939V61.8502V61.8525V61.8613L0.223651 61.8621C0.228085 62.2708 0.498571 62.6787 1.03881 62.9906L34.0923 82.074C34.6369 82.3881 35.3509 82.5455 36.0648 82.5455V62.1821L16.9799 50.8977L11.7918 53.893L0.222168 57.3939Z"
      fill="#A5CBFA"
    />
    <path
      d="M104.058 36.1288L95.9562 31.4529C95.2305 31.0339 94.0532 31.0339 93.3267 31.4529L92.8729 31.7145C92.1472 32.1336 90.9699 32.1336 90.2434 31.7145L80.5406 26.1126C79.8149 25.6936 79.8149 25.0137 80.5406 24.5946L80.9936 24.333C81.7194 23.914 81.7194 23.2341 80.9936 22.815L72.7852 18.0808C72.0594 17.6617 70.8821 17.6617 70.1557 18.0808L4.98732 55.7273C4.26159 56.1464 4.26159 56.8263 4.98806 57.2453L36.2619 75.2926C36.9884 75.7116 38.1657 75.7116 38.8914 75.2926L104.057 37.6468C104.783 37.2277 104.783 36.5478 104.058 36.1288Z"
      fill="#031F60"
    />
    <path
      d="M94.6407 30.6937L105.406 36.8684L103.924 39.6132L94.6407 34.2544V30.6937Z"
      fill="#1E3779"
    />
    <path
      d="M71.4697 20.8823V17.3217L82.3085 23.5739L79.2259 25.3543L71.4697 20.8823Z"
      fill="#1E3779"
    />
    <path
      d="M38.8922 75.2924L103.792 37.7995L95.9555 33.2774C95.2298 32.8583 94.0525 32.8583 93.326 33.2774L92.8722 33.539C92.1465 33.958 90.9692 33.958 90.2428 33.539L80.5399 27.9371C79.8142 27.5181 79.8142 26.8381 80.5399 26.4191L80.8053 26.2654L80.5399 26.1124C79.8142 25.6934 79.8142 25.0135 80.5399 24.5944L80.7284 24.4858L72.7845 19.9045C72.0587 19.4855 70.8814 19.4855 70.155 19.9045L5.25269 57.3974L36.262 75.2909C36.9892 75.7114 38.1657 75.7114 38.8922 75.2924Z"
      fill="#344593"
    />
    <path
      d="M95.9555 33.2774C95.2297 32.8584 94.0524 32.8584 93.3259 33.2774L92.8722 33.5391C92.1464 33.9581 90.9692 33.9581 90.2427 33.5391L80.5399 27.9371C79.8141 27.5181 79.8141 26.8382 80.5399 26.4192L80.8052 26.2654L80.5399 26.1125C79.8141 25.6934 79.8141 25.0135 80.5399 24.5945L80.7283 24.4858L72.7844 19.9045C72.4215 19.6947 71.9456 19.5905 71.4697 19.5905C71.4697 19.5905 75.8034 30.526 72.1052 42.0136C68.6554 52.7296 48.5521 69.4932 40.4685 74.3805L103.791 37.7989L95.9555 33.2774Z"
      fill="#2B3D89"
    />
    <path
      d="M79.996 25.3542V27.1789C80.0011 27.4856 80.1999 27.7332 80.5406 27.9379L90.2435 33.5398C90.5797 33.7386 91.0298 33.8532 91.6329 33.8524V31.5104L79.996 25.3542Z"
      fill="#1E3779"
    />
    <path
      d="M108.078 34.8939L75.026 15.8104C73.9366 15.1815 72.171 15.1815 71.0817 15.8104L1.03869 56.2557C-0.0506557 56.8847 -0.0506557 57.9038 1.03869 58.5327L34.0921 77.6154C35.1815 78.2443 36.947 78.2443 38.0356 77.6154L108.078 37.1708C109.167 36.5419 109.167 35.522 108.078 34.8939ZM104.058 37.646L38.8922 75.2926C38.1665 75.7116 36.9892 75.7116 36.2627 75.2926L4.98884 57.2453C4.26311 56.8263 4.26311 56.1471 4.9881 55.7273L70.1564 18.0808C70.8822 17.6617 72.0594 17.6617 72.7859 18.0808L80.9937 22.815C81.7194 23.2341 81.7194 23.914 80.9937 24.333L80.5407 24.5946C79.8149 25.0137 79.8149 25.6936 80.5407 26.1126L90.2435 31.7145C90.9692 32.1336 92.1465 32.1336 92.873 31.7145L93.3267 31.4529C94.0525 31.0339 95.2298 31.0339 95.9562 31.4529L104.058 36.1288C104.783 36.5478 104.783 37.2277 104.058 37.646Z"
      fill="#DCEEFF"
    />
    <g opacity="0.4">
      <path
        d="M27.8056 42.5455L33.4504 39.2849H30.4278L24.7808 42.5455H27.8056Z"
        fill="#FAFDFF"
      />
      <path
        d="M49.0405 30.2791L60.3286 23.7578H57.3185L46.0253 30.2791H49.0405Z"
        fill="#FAFDFF"
      />
      <path
        d="M72.0704 17.8337C72.3306 17.8847 72.5781 17.9609 72.7851 18.0806L76.362 20.1432H82.5308L78.5304 17.8337H72.0704Z"
        fill="#FAFDFF"
      />
      <path
        d="M63.5774 20.144H66.5853L70.1563 18.0813C70.364 17.9616 70.6116 17.8855 70.871 17.8345H67.5778L63.5774 20.144Z"
        fill="#FAFDFF"
      />
      <path
        d="M81.5079 23.7578C81.4451 23.9684 81.2759 24.1702 80.9935 24.3328L80.5405 24.5944C79.8148 25.0134 79.8148 25.6934 80.5405 26.1124L87.7565 30.2783H100.086L88.7911 23.7571L81.5079 23.7578Z"
        fill="#FAFDFF"
      />
      <path
        d="M11.4249 52.0082L22.7137 45.4877H19.6858L8.39258 52.0082H11.4249Z"
        fill="#FAFDFF"
      />
      <path
        d="M35.7383 74.99L24.4377 68.4688H18.249L29.5437 74.99H35.7383Z"
        fill="#FAFDFF"
      />
      <path
        d="M101.22 39.2849L95.577 42.5455H98.7689L104.416 39.2849H101.22Z"
        fill="#FAFDFF"
      />
      <path
        d="M90.4844 45.4877L79.1963 52.0082H82.3815L93.674 45.4877H90.4844Z"
        fill="#FAFDFF"
      />
      <path
        d="M19.3401 65.5267L13.6894 62.2661H7.50659L13.1543 65.5267H19.3401Z"
        fill="#FAFDFF"
      />
      <path
        d="M61.4393 62.2661L55.7953 65.5267H58.9695L64.6157 62.2661H61.4393Z"
        fill="#FAFDFF"
      />
      <path
        d="M50.7033 68.4688L39.4153 74.99H42.5821L53.8746 68.4688H50.7033Z"
        fill="#FAFDFF"
      />
    </g>
    <path
      d="M85.1656 25.23L89.8733 27.9467C90.2768 28.1795 90.3485 28.5165 90.0329 28.6991C89.7173 28.8809 89.1342 28.8395 88.7307 28.6067L84.023 25.8907C83.6195 25.6579 83.5478 25.3209 83.8634 25.1384C84.179 24.9551 84.7621 24.9972 85.1656 25.23Z"
      fill="#031F60"
    />
    <path
      d="M15.105 69.0499C15.105 68.5415 16.1773 68.7469 17.4995 69.5111C18.8223 70.2745 19.8939 71.3062 19.8939 71.8154V72.737L15.105 69.9722C15.105 69.9722 15.105 69.5591 15.105 69.0499Z"
      fill="#7AA3E5"
    />
    <path
      d="M21.3733 73.3014C21.3733 73.4943 21.5093 73.7293 21.6763 73.8254C21.8433 73.9222 21.9786 73.8439 21.9786 73.651C21.9786 73.4581 21.8426 73.2231 21.6756 73.1263C21.5085 73.0302 21.3733 73.1078 21.3733 73.3014Z"
      fill="#7AA3E5"
    />
    <path
      d="M22.8677 74.1632C22.8677 74.3561 23.0029 74.5911 23.1699 74.6872C23.337 74.784 23.4722 74.7057 23.4722 74.5128C23.4722 74.3199 23.3362 74.0849 23.1692 73.9881C23.0022 73.892 22.8669 73.9703 22.8677 74.1632Z"
      fill="#7AA3E5"
    />
    <path
      d="M24.3611 75.0256C24.3611 75.2185 24.4963 75.4535 24.6634 75.5496C24.8304 75.6464 24.9656 75.5681 24.9656 75.3752C24.9656 75.1823 24.8296 74.9473 24.6626 74.8512C24.4956 74.7544 24.3603 74.8327 24.3611 75.0256Z"
      fill="#7AA3E5"
    />
    <path
      d="M25.855 75.8882C25.855 76.0811 25.9902 76.3161 26.1572 76.4121C26.3243 76.509 26.4595 76.4306 26.4595 76.2377C26.4595 76.0448 26.3235 75.8098 26.1565 75.7138C25.9902 75.6169 25.8542 75.6953 25.855 75.8882Z"
      fill="#7AA3E5"
    />
    <path
      d="M27.3484 76.7505C27.3484 76.9434 27.4836 77.1784 27.6507 77.2745C27.8177 77.3713 27.9529 77.2929 27.9529 77.1001C27.9529 76.9072 27.8177 76.6722 27.6499 76.5753C27.4829 76.4793 27.3484 76.5576 27.3484 76.7505Z"
      fill="#7AA3E5"
    />
    <path
      d="M28.8419 77.613C28.8419 77.8059 28.9772 78.041 29.1442 78.1378C29.3112 78.2338 29.4465 78.1555 29.4465 77.9626C29.4465 77.7697 29.3105 77.5347 29.1435 77.4379C28.9764 77.3418 28.8412 77.4202 28.8419 77.613Z"
      fill="#7AA3E5"
    />
    <path
      d="M30.3356 78.4748C30.3356 78.6677 30.4716 78.9027 30.6378 78.9988C30.8049 79.0956 30.9401 79.0172 30.9401 78.8243C30.9401 78.6315 30.8049 78.3964 30.6371 78.2996C30.4708 78.2043 30.3348 78.2819 30.3356 78.4748Z"
      fill="#7AA3E5"
    />
    <path
      d="M21.335 71.7437C21.335 71.9365 21.4709 72.1716 21.638 72.2684C21.805 72.3645 21.9402 72.2869 21.9402 72.0932C21.9402 71.9003 21.8043 71.6653 21.6372 71.5685C21.4702 71.4724 21.335 71.5508 21.335 71.7437Z"
      fill="#7AA3E5"
    />
    <path
      d="M22.8284 72.6061C22.8291 72.799 22.9643 73.034 23.1314 73.1308C23.2984 73.2269 23.4336 73.1485 23.4336 72.9556C23.4336 72.7628 23.2977 72.5277 23.1306 72.4309C22.9636 72.3349 22.8284 72.4132 22.8284 72.6061Z"
      fill="#7AA3E5"
    />
    <path
      d="M24.322 73.4686C24.322 73.6615 24.4573 73.8965 24.6243 73.9933C24.7913 74.0901 24.9266 74.0118 24.9266 73.8189C24.9266 73.626 24.7906 73.391 24.6236 73.2942C24.4573 73.1974 24.322 73.2757 24.322 73.4686Z"
      fill="#7AA3E5"
    />
    <path
      d="M25.8157 74.3309C25.8157 74.5238 25.9517 74.7588 26.1187 74.8557C26.2857 74.9517 26.4209 74.8741 26.4209 74.6805C26.4209 74.4876 26.285 74.2526 26.1187 74.1558C25.9509 74.0597 25.8157 74.138 25.8157 74.3309Z"
      fill="#7AA3E5"
    />
    <path
      d="M27.3091 75.1935C27.3091 75.3864 27.4443 75.6214 27.6114 75.7174C27.7784 75.8143 27.9136 75.7359 27.9136 75.543C27.9136 75.3501 27.7784 75.1151 27.6114 75.0191C27.4443 74.9222 27.3091 75.0006 27.3091 75.1935Z"
      fill="#7AA3E5"
    />
    <path
      d="M28.8029 76.055C28.8029 76.2479 28.9381 76.4829 29.1051 76.5798C29.2721 76.6766 29.4074 76.5982 29.4074 76.4053C29.4074 76.2117 29.2721 75.9774 29.1051 75.8806C28.9388 75.7838 28.8029 75.8621 28.8029 76.055Z"
      fill="#7AA3E5"
    />
    <path
      d="M30.2972 76.9183C30.2972 77.1112 30.4325 77.3462 30.5995 77.443C30.7665 77.5391 30.9018 77.4615 30.9018 77.2679C30.9018 77.075 30.7665 76.84 30.5995 76.7432C30.4325 76.6463 30.2965 76.7247 30.2972 76.9183Z"
      fill="#7AA3E5"
    />
    <path
      d="M3.80566 63.1539C3.80566 63.3468 3.94164 63.5818 4.10867 63.6787C4.27569 63.7755 4.41093 63.6971 4.41093 63.5035C4.41093 63.3106 4.27569 63.0756 4.10867 62.9788C3.94091 62.8827 3.80566 62.961 3.80566 63.1539Z"
      fill="#7AA3E5"
    />
    <path
      d="M5.29907 64.0163C5.29907 64.2092 5.43505 64.4442 5.60134 64.541C5.76836 64.6379 5.90361 64.5595 5.90361 64.3666C5.90361 64.1737 5.76836 63.9387 5.60134 63.8427C5.43431 63.7451 5.29907 63.8234 5.29907 64.0163Z"
      fill="#7AA3E5"
    />
    <path
      d="M6.79297 64.879C6.79297 65.0719 6.92895 65.3069 7.09523 65.403C7.26226 65.4998 7.3975 65.4215 7.3975 65.2286C7.3975 65.0357 7.26226 64.8007 7.09523 64.7046C6.92821 64.6078 6.79297 64.6861 6.79297 64.879Z"
      fill="#7AA3E5"
    />
    <path
      d="M8.28638 65.7413C8.28638 65.9342 8.42236 66.1692 8.58939 66.266C8.75641 66.3629 8.89165 66.2845 8.89165 66.0909C8.89165 65.898 8.75641 65.663 8.58939 65.5669C8.42162 65.4701 8.28638 65.5484 8.28638 65.7413Z"
      fill="#7AA3E5"
    />
    <path
      d="M9.77979 66.6039C9.78052 66.7968 9.91577 67.0318 10.082 67.1286C10.2491 67.2254 10.3851 67.1471 10.3851 66.9542C10.3851 66.7613 10.2498 66.5263 10.082 66.4302C9.91503 66.3326 9.77979 66.4102 9.77979 66.6039Z"
      fill="#7AA3E5"
    />
    <path
      d="M11.2737 67.4655C11.2744 67.6584 11.4097 67.8934 11.5767 67.9903C11.7437 68.0871 11.879 68.0087 11.879 67.8158C11.879 67.623 11.7437 67.3879 11.5767 67.2919C11.4089 67.1943 11.2737 67.2727 11.2737 67.4655Z"
      fill="#7AA3E5"
    />
    <path
      d="M12.7681 68.3287C12.7681 68.5216 12.9033 68.7566 13.0703 68.8527C13.2366 68.9495 13.3726 68.8712 13.3726 68.6783C13.3726 68.4854 13.2366 68.2504 13.0696 68.1536C12.9026 68.0567 12.7673 68.1351 12.7681 68.3287Z"
      fill="#7AA3E5"
    />
    <path
      d="M3.76733 61.5968C3.76733 61.7897 3.90331 62.0247 4.0696 62.1208C4.23662 62.2176 4.37187 62.1393 4.37187 61.9464C4.37187 61.7535 4.23662 61.5185 4.0696 61.4217C3.90258 61.3256 3.76733 61.4039 3.76733 61.5968Z"
      fill="#7AA3E5"
    />
    <path
      d="M5.26099 62.4594C5.26099 62.6522 5.39623 62.8873 5.56326 62.9833C5.73028 63.0794 5.86552 63.0018 5.86552 62.8089C5.86552 62.6153 5.73028 62.381 5.56326 62.2842C5.39623 62.1881 5.26099 62.2665 5.26099 62.4594Z"
      fill="#7AA3E5"
    />
    <path
      d="M6.75464 63.3218C6.75464 63.5147 6.89062 63.7497 7.0569 63.8465C7.22393 63.9426 7.35917 63.8642 7.35917 63.6714C7.35917 63.4785 7.22393 63.2434 7.0569 63.1466C6.88988 63.0506 6.75464 63.1289 6.75464 63.3218Z"
      fill="#7AA3E5"
    />
    <path
      d="M8.24805 64.1842C8.24805 64.3771 8.38403 64.6121 8.55106 64.7082C8.71808 64.805 8.85332 64.7266 8.85332 64.5337C8.85332 64.3408 8.71808 64.1058 8.55106 64.009C8.38329 63.9122 8.24805 63.9906 8.24805 64.1842Z"
      fill="#7AA3E5"
    />
    <path
      d="M9.7417 65.0467C9.7417 65.2396 9.87694 65.4746 10.0447 65.5707C10.2117 65.6668 10.347 65.5892 10.347 65.3963C10.347 65.2027 10.211 64.9684 10.044 64.8716C9.87694 64.7748 9.7417 64.8531 9.7417 65.0467Z"
      fill="#7AA3E5"
    />
    <path
      d="M11.2351 65.9092C11.2351 66.102 11.3711 66.3371 11.5381 66.4339C11.7051 66.5299 11.8404 66.4523 11.8404 66.2587C11.8404 66.0658 11.7044 65.8308 11.5374 65.734C11.3704 65.6372 11.2351 65.7155 11.2351 65.9092Z"
      fill="#7AA3E5"
    />
    <path
      d="M12.729 66.7709C12.729 66.9638 12.865 67.1988 13.032 67.2948C13.199 67.3917 13.3343 67.3133 13.3343 67.1204C13.3343 66.9275 13.199 66.6925 13.032 66.5964C12.8642 66.4996 12.729 66.578 12.729 66.7709Z"
      fill="#7AA3E5"
    />
    <path
      d="M90.582 28.9918C90.2761 29.1685 90.2761 29.4545 90.5828 29.6311C90.8887 29.8077 91.3846 29.8077 91.6899 29.6311C91.9958 29.4545 91.9958 29.1685 91.6899 28.9918C91.3832 28.8152 90.8873 28.8152 90.582 28.9918Z"
      fill="#031F60"
    />
    <g opacity="0.6">
      <path
        d="M67.9207 13.1432C67.9207 9.73402 65.5048 8.33946 62.5531 10.0444L62.4984 10.0762C59.546 11.7804 56.9394 15.9582 56.7058 19.3592L56.473 22.7551C56.3445 24.6301 54.5419 27.1302 52.4468 28.34C50.3523 29.5491 48.6533 28.5477 48.6518 26.1022L48.6496 23.0685C48.6481 20.3281 46.7037 19.2048 44.3292 20.5735C42.0729 21.8735 40.0509 25.0609 39.8366 27.6564L39.5107 31.6073C39.3104 34.0343 37.4214 37.0156 35.3122 38.2335L34.9737 38.4286C32.8645 39.6458 30.9386 38.66 30.6932 36.2374L28.9808 19.343C28.6372 15.9515 25.9404 14.571 22.988 16.2752L22.9333 16.307C19.9808 18.0112 17.5657 22.1957 17.5657 25.6049V60.939L67.9215 31.8667L67.9207 13.1432Z"
        fill="#A6C3FF"
      />
      <path
        d="M67.9207 31.8645V13.1432C67.9207 9.73402 65.5048 8.33946 62.5531 10.0444L62.4984 10.0762C59.546 11.7804 56.9394 15.9582 56.7058 19.3592L56.473 22.7551C56.3445 24.6301 54.5419 27.1302 52.4468 28.34C50.3523 29.5491 48.6533 28.5477 48.6518 26.1022L48.6496 23.0685C48.6481 20.3281 46.7037 19.2048 44.3292 20.5735C42.0729 21.8735 40.0509 25.0609 39.8366 27.6564L39.5107 31.6073C39.3104 34.0343 37.4214 37.0156 35.3122 38.2335L34.9737 38.4286C32.8645 39.6458 30.9386 38.66 30.6932 36.2374L28.9808 19.343C28.6372 15.9515 25.9404 14.571 22.988 16.2752L22.9333 16.307C19.9808 18.0112 17.5657 22.1957 17.5657 25.6049V60.939"
        stroke="#E9FFFB"
        strokeWidth="0.636965"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <path
      opacity="0.8"
      d="M70.5164 30.292C70.3183 32.7286 68.4389 35.6914 66.3179 36.9086C64.1606 38.1465 62.1327 37.1754 61.7528 34.7602C61.7528 34.7602 61.5045 33.1824 61.1978 31.2358C60.8911 29.2891 59.1847 28.553 57.3859 29.5914C55.5871 30.6297 53.8282 33.4307 53.4564 35.8473L52.696 40.793C52.3242 43.2096 50.6333 45.9707 48.9202 46.9603C47.2064 47.9498 45.565 46.7858 45.2546 44.3603L43.7957 35.8954C43.2141 32.5217 40.3392 31.1744 37.375 32.886L37.3203 32.9178C34.356 34.6294 31.9526 38.7917 31.9526 42.2149V69.243L82.3084 40.1707V4.83659C82.3084 1.41336 80.1431 -0.116439 77.4722 1.41928C74.8013 2.955 72.4113 6.96649 72.1341 10.3786L70.5164 30.292Z"
      fill="#A6C3FF"
    />
    <path
      d="M82.3085 40.1707V4.83659C82.3085 1.41336 80.1431 -0.116439 77.4722 1.41928C74.8013 2.955 72.4113 6.96649 72.1341 10.3786L70.5164 30.2913C70.3183 32.7279 68.4389 35.6907 66.3179 36.9079C64.1606 38.1458 62.1327 37.1747 61.7528 34.7595C61.7528 34.7595 61.5045 33.1816 61.1978 31.235C60.8911 29.2884 59.1847 28.5523 57.3859 29.5907C55.5871 30.629 53.8282 33.43 53.4564 35.8466L52.696 40.7922C52.3242 43.2089 50.6333 45.9699 48.9202 46.9595C47.2064 47.9491 45.565 46.7851 45.2546 44.3596L43.7957 35.8946C43.2141 32.5209 40.3392 31.1737 37.375 32.8853L37.3203 32.9171C34.356 34.6287 31.9526 38.7909 31.9526 42.2142V69.2422"
      stroke="#E9FFFB"
      strokeWidth="0.636965"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </SvgIcon>
);
